import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, database } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import getCustomErrorMessage from "../../utils/firebaseErrors";
import type { FirebaseError } from "firebase/app";
import UserRole from "../../interfaces/UserRole";

interface UserAdmin {
  name: string;
  lastName: string;
  email: string;
  password: string;
  countryCode: string;
  phone: string;
  role: UserRole;
}

export async function loginAdminService(credential: {
  email: string;
  password: string;
}) {
  const { email, password } = credential;
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;

    const userDocRef = doc(database, "users", user.uid);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      throw new Error(
        "No se encontró información del usuario en la base de datos."
      );
    }

    const userData = { id: user.uid, ...(userDocSnap.data() as UserAdmin) };

    // Solo Admin y Digitador pueden acceder
    if (!userData?.role || (userData.role !== UserRole.Admin && userData.role !== UserRole.Digitador)) {
      await auth.signOut();
      toast.error("No tienes permisos para acceder.");
      return null;
    }

    toast.success("Ingreso exitoso");
    return userData as UserAdmin;
  } catch (error) {
    const firebaseError = error as FirebaseError;
    toast.error(getCustomErrorMessage(firebaseError.code));
    return null;
  }
}
